

















import { Component, Ref } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import XsollaWidget from '@/components/xsolla/XsollaWidget.vue';

import LocaleMixin from '@/mixins/locale';

import {
  PROJECT_ID as projectId,
  CLIENT_ID as clientId,
  CALLBACK_URL as callbackUrl,
  REDIRECT_URI as redirectUri,
  SETTINGS_JSON_URL as settingsJsonUrl,
  SOCIALS_JSON_URL as socialsJsonUrlRu,
} from '@/config/xsolla';

import { ISO_LOCALES } from '@/locales';

import { buildStateParamsString } from '@/helpers/auth';

@Component({
  components: { XsollaWidget },
})
export default class XsollaModal extends mixins(LocaleMixin) {
  @Ref() readonly widget!: XsollaWidget;

  state: string = this.$oauth.refreshState();

  get projectId() {
    return projectId;
  }

  get clientId() {
    return clientId;
  }

  get callbackUrl() {
    return callbackUrl;
  }

  get redirectUri() {
    return redirectUri;
  }

  get settingsJsonUrl(): string | null {
    return settingsJsonUrl || null;
  }

  get socialsJsonUrl(): string | null {
    if (this.locale === 'ru' && socialsJsonUrlRu) {
      return socialsJsonUrlRu;
    }
    return null;
  }

  get preferredLocale() {
    return ISO_LOCALES[this.locale];
  }

  get stateParams() {
    return buildStateParamsString({
      state: this.state,
      from: this.$route.name as string,
    });
  }

  show() {
    this.widget.open();
  }

  close() {
    this.widget.close();
  }
}
